import { Link } from "react-router-dom";

/**
 * BrandMark — small Aynora logo + wordmark used consistently across every screen.
 *
 * Variants:
 *  - "kicker" (default) : compact icon + "AYNORA · MIRROR OF LIGHT" tag, aligned to
 *    the start. Good above a page heading.
 *  - "center"           : centered vertically stacked icon + wordmark. Good for auth /
 *    onboarding / entry screens.
 */
export default function BrandMark({ variant = "kicker", to = "/home", className = "" }) {
  if (variant === "center") {
    return (
      <div className={`flex flex-col items-center ${className}`} data-testid="brand-mark-center">
        <img
          src="/aynora-logo.png"
          alt="Aynora"
          className="w-16 h-16 rounded-2xl shadow-[0_10px_30px_rgba(107,122,84,0.25)]"
        />
        <div className="mt-3 font-[Cormorant_Garamond] italic text-2xl text-stone-900">Aynora</div>
        <div className="text-[10px] font-[Manrope] font-bold tracking-[0.3em] uppercase text-[#6B7A54] mt-1">
          Mirror of Light
        </div>
      </div>
    );
  }

  return (
    <Link
      to={to}
      data-testid="brand-mark-kicker"
      className={`inline-flex items-center gap-2 group ${className}`}
    >
      <img
        src="/aynora-logo.png"
        alt="Aynora"
        className="w-7 h-7 rounded-md shadow-[0_4px_10px_rgba(107,122,84,0.2)]"
      />
      <span className="text-[10px] font-[Manrope] font-bold tracking-[0.3em] uppercase text-stone-500 group-hover:text-[#6B7A54] transition-colors">
        Aynora <span className="text-[#6B7A54]">·</span> Mirror of Light
      </span>
    </Link>
  );
}
